<script lang="ts">
  import type { RichTextInlineComponentProps } from './types';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  type $$Props = RichTextInlineComponentProps;

  export let value: RichTextInlineComponentProps['value'] = undefined;
  export let marks: RichTextInlineComponentProps['marks'];
  export let element: RichTextInlineComponentProps['element'] = undefined;
  export let nodeType: RichTextInlineComponentProps['nodeType'];
  export let data: RichTextInlineComponentProps['data'] = undefined;
  export let content: RichTextInlineComponentProps['content'] = undefined;

  const bold = marks.includes('bold');
  const italic = marks.includes('italic');
  const underline = marks.includes('underline');
  const superscript = marks.includes('superscript');
  const subscript = marks.includes('subscript');
  const code = marks.includes('code');
</script>

{#if nodeType === 'text'}
  {#if element === 'span' && marks.length === 0}
    {value}
  {:else}
    <svelte:element
      this={element}
      style:font-weight={bold ? 'bold' : ''}
      style:font-style={italic ? 'italic' : ''}
      style:text-decoration={underline ? 'underline' : ''}
      style:vertical-align={superscript ? 'super' : subscript ? 'sub' : ''}
      style:font-size={superscript || subscript ? 'smaller' : ''}
      style:font-family={code ? 'monospace' : ''}
      style:background-color={code ? '#f8f8f8' : ''}
      style:padding={code ? '2px 4px' : ''}
      style:border-radius={code ? '3px' : ''}
    >
      {value}
    </svelte:element>
  {/if}
{:else if nodeType === 'hyperlink'}
  <a href={data?.uri}>
    {#if content}
      {#each content as inline}
        <DynamicChildrenComponent children={inline} />
      {/each}
    {/if}
  </a>
{/if}
